// @ts-nocheck
// import React, { useCallback, useEffect, useRef, useState } from 'react';
namespace React { export type FC = {} };
// declare var useEffect, useState;
const useCallback = React.useCallback;
const useEffect = React.useEffect;
const useRef = React.useRef;
const useState = React.useState;

// NOTE: originally, “interfaces” (yes, but)
import { DropDownBook, DropDownCategory } from './models';

import {
    ReactTreeSelect,
    updateCategorySelection,
    updateAncestorCategories,
} from './components/ReactTreeSelect';

interface TreeSelectWrapperProps
{
    openAtStart: boolean;
    adapter: ReactTreeSelectAdapter;
    eventsHub: EventTarget; // outbound / common
    inboundEventsHub: EventTarget;
    sharedData: ISharedData;
    l10n: ReactLocalization;
    enableFilter: boolean;
    legacy: boolean;
    enableFavorites: boolean;
}

const ReactTreeSelectWrapper: React.FC<TreeSelectWrapperProps> = ({
    openAtStart,
    adapter,
    eventsHub,
    inboundEventsHub,
    sharedData,
    l10n,
    enableFilter,
    legacy,
    enableFavorites,
}) =>
{
    let LocalizationProvider = window['FluentReact'].LocalizationProvider;

    //  XXX: unavailable due to CORS (Access-Control-Allow-Origin)
    const dataUrl = 'https://localhost:44368/Dictionaries/Dictionaries/GetDictionariesWithCategories';
    // const dataUrl = '/data/GetDictionariesWithCategories.json';

    // @ts-ignore
    const [initialized, setInitialized] = useState<boolean>(false);

    // @ts-ignore
    const [books, setBooks] = useState<{ [id: number]: DropDownBook }>({});
    // @ts-ignore
    const [categories, setCategories] = useState<{ [id: number]: DropDownCategory }>({});
    const [filter, setFilter] = useState<string>('');
    // @ts-ignore
    const [rootCategoryId, setRootCategoryId] = useState<number | null>(null);

    const stateRef = useRef({
        initialized,
        books,
        categories,
        filter,
    });

    const setInitializedWrapper = (updatedInitialized) =>
    {
        stateRef.current.initialized = updatedInitialized;
        sharedData.initialized = updatedInitialized;

        setInitialized(updatedInitialized);
    }

    const setBooksWrapper = (updatedBooks) =>
    {
        stateRef.current.books = updatedBooks;

        setBooks(updatedBooks);
    }

    const setCategoriesWrapper = (updatedCategories) =>
    {
        stateRef.current.categories = updatedCategories;

        setCategories(updatedCategories);
    }

    const setFilterWrapper = (updatedFilter: string) =>
    {
        stateRef.current.filter = updatedFilter;

        setFilter(updatedFilter);
    }

    const gotData = (payload) =>
    // useEffect(() =>
    {
        const data = payload.response;
        /*
        fetch(dataUrl)
        .then(response => response.json())
        .then(data =>
        {
        */
            const books: { [id: number]: DropDownBook } = {};
            const categories: { [id: number]: DropDownCategory } = {};

            let newRootCategoryId = null;

            if (false)
            data = {
                "bookType": "Dictionary",
                "categories": [
                    {
                        "id": 12,
                        "parentCategoryId": null,
                        "externalId": "output-dictionary",
                        "description": "Vybrat prohledávané slovníky"
                    },
                    {
                        "id": 14,
                        "parentCategoryId": 12,
                        // TODO: drop the 'diachronic'
                        "externalId": "output-dictionary-diachronic-period",
                        "description": "dobové slovníky"
                    },
                    {
                        "id": 13,
                        "parentCategoryId": 12,
                        "externalId": "output-dictionary-diachronic-modern",
                        "description": "moderní diachronní slovníky",
                        "selected": true,
                        "isOpen": true,
                    },
                    {
                        "id": 15,
                        "parentCategoryId": 14,
                        "externalId": "sranda",
                        "description": "sranda"
                    }
                ],
                "books": [
                    {
                        "id": 20079,
                        "guid": null,
                        "title": "Dictionarium latino-bohemicum",
                        "subTitle": null,
                        "categoryIds": [
                            12,
                            14,
                            15
                        ]
                    },
                    {
                        "id": 20077,
                        "guid": null,
                        "title": "Elektronický slovník staré češtiny",
                        "subTitle": null,
                        "categoryIds": [
                            13
                        ]
                    },
                    {
                        "id": 30079,
                        "guid": null,
                        "title": "Malý staročeský slovník",
                        "subTitle": null,
                        "categoryIds": [
                            13, 15
                        ]
                    },
                    {
                        "id": 9,
                        "guid": null,
                        "title": "Vokabulář latinský, český i německý",
                        "subTitle": null,
                        "categoryIds": [
                            14
                        ]
                    }
                ]
            };

            //  XXX: this Object doesn’t preserve original/insertion order, the
            //       keys will be sorted by the ID
            // TODO: so when presenting the list of books – or even categories –
            //       we need to sort the items by our own key instead (modern
            //       dictionaries even have one)
            // TODO: a Map (instead of an object) preserves insertion order
            // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#objects_vs._maps
            data.books.forEach((book: any) =>
            {
                books[book.id] = {
                    id: book.id,
                    name: book.title,
                    linkingAbbreviation: book.linkingAbbreviation,
                    sourceAbbreviation: book.sourceAbbreviation,
                    sourcePartAbbreviation: book.sourcePartAbbreviation,
                    categoryIds: book.categoryIds,
                    selected: !!book.selected,
                    // DOM/jQuery
                    checkboxes: null,
                };
            });

            data.categories.forEach((cat: any) =>
            {
                categories[cat.id] = {
                    id: cat.id,
                    name: cat.description,
                    parentCategoryId: cat.parentCategoryId,
                    subcategoryIds: [],
                    bookIds: [],
                    externalId: cat.externalId,
                    selected: !!cat.selected,
                    isOpen: !!cat.isOpen,
                    // DOM/jQuery
                    checkBox: null,
                    moreSpan: null,
                };
            });

            Object.values(categories).forEach(category =>
            {
                const parentId = category.parentCategoryId;

                if (parentId === null) {
                    newRootCategoryId = category.id;

                } else {
                    categories[parentId].subcategoryIds.push(category.id);
                }
            });

            // Populate categories with books. (And no other operation!)
            Object.values(books).forEach(book =>
            {
                book.categoryIds.forEach(catId =>
                {
                    categories[catId].bookIds.push(book.id);
                });
            });

            Object.values(books).forEach(book =>
            {
                const categoryIds = book.categoryIds;

                if (!book.selected)
                    return;

                //  XXX: we cannot do this in the previous loop because categories
                //       are not yet populated with books; we would’ve marked a
                //       category as selected while it only contained a single book
                updateAncestorCategories(
                    categoryIds, books, categories, openAtStart);
            });

            Object.values(categories).forEach(category =>
            {
                if (category.selected) {
                    updateCategorySelection(
                        category.id, true, books, categories);
                }

                if (category.selected || category.isOpen) {
                    updateAncestorCategories(
                        [category.parentCategoryId], books, categories, openAtStart)
                }
            });

            setBooksWrapper(books);
            setCategoriesWrapper(categories);
            setRootCategoryId(newRootCategoryId);

            setInitializedWrapper(true);

            if (!legacy) {
                adapter.sendFullState(books, categories);
            }
        // });
    // }, [dataUrl]);
    }

    // DONE: maybe use a data ref instead of useCallback?
    // NOTE: the old version of the function was probably kept in the callbacks
    //       object
    const openCloseCategory = (payload) =>
    {
        //  XXX: well, messages are asynchronous (they are, aren’t they?) so we
        //       got here (from doRestore) earlier that gotData…
        if (!stateRef.current.initialized)
            return;

        const categoryId = payload.categoryId;
        const isOpen = payload.isOpen;

        //  XXX: yes, we DO need to make a copy so React even recognizes a
        //       change in setCategories…
        const updatedCategories: { [id: number]: DropDownCategory } = {
            ...stateRef.current.categories };

        const category = updatedCategories[categoryId];
        category.isOpen = isOpen;

        setCategoriesWrapper(updatedCategories);
    }

    // TODO: deduplicate (handleCategorySelect)
    const selectUnselectCategory = (payload) =>
    {
        if (!stateRef.current.initialized)
            return;

        const categoryId = payload.categoryId;
        const selected = payload.selected;

        //  XXX: yes, we DO need to make a copy so React even recognizes a
        //       change in setCategories…
        const updatedBooks: { [id: number]: DropDownBook } = {
            ...stateRef.current.books };
        const updatedCategories: { [id: number]: DropDownCategory } = {
            ...stateRef.current.categories };

        const categoryIds = updateCategorySelection(
            categoryId, selected, updatedBooks, updatedCategories);

        updateAncestorCategories(
            categoryIds, updatedBooks, updatedCategories, false);

        setBooksWrapper(updatedBooks);
        setCategoriesWrapper(updatedCategories);
    }

    const selectUnselectBook = (payload) =>
    {
        if (!stateRef.current.initialized)
            return;

        const bookId = payload.bookId;
        const selected = payload.selected;

        //  XXX: yes, we DO need to make a copy so React even recognizes a
        //       change in setCategories…
        const updatedBooks: { [id: number]: DropDownBook } = {
            ...stateRef.current.books };
        const updatedCategories: { [id: number]: DropDownCategory } = {
            ...stateRef.current.categories };

        const book = updatedBooks[bookId];
        book.selected = selected;

        const categoryIds = book.categoryIds;
        updateAncestorCategories(
            categoryIds, updatedBooks, updatedCategories, false);

        setBooksWrapper(updatedBooks);
        setCategoriesWrapper(updatedCategories);
    }

    const setSelected = (data: {
        additive: boolean, // if not true, reset/unselect everything first
        bookIds: Array<number>;
        categoryIds: Array<number>;
        externalCategoryIds: Array<string>;
    }) =>
    {
        if (!stateRef.current.initialized)
            return;

        const additive = data.additive;
        const bookIds = data.bookIds ?? [];
        const categoryIds = data.categoryIds ?? [];
        const externalCategoryIds = data.externalCategoryIds ?? [];

        const updatedBooks: { [id: number]: DropDownBook } = {
            ...stateRef.current.books };
        const updatedCategories: { [id: number]: DropDownCategory } = {
            ...stateRef.current.categories };

        if (!additive) {
            Object.values(updatedBooks).forEach((book) =>
            {
                book.selected = false;
            });

            Object.values(updatedCategories).forEach((category) =>
            {
                category.selected = false;
                // let’s leave isOpen unchanged
            });
        }

        let affectedCategoryIds = new Set<number>();

        bookIds.forEach((bookId) =>
        {
            const book = updatedBooks[bookId];

            if (!book)
                return;

            book.selected = true;

            book.categoryIds.forEach((categoryId) =>
            {
                affectedCategoryIds.add(categoryId);
            });
        });

        categoryIds.forEach((categoryId) =>
        {
            const category = updatedCategories[categoryId];

            if (!category)
                return;

            const categoryIds = updateCategorySelection(
                category.id, true, updatedBooks, updatedCategories);

            for (let categoryId of categoryIds)
                affectedCategoryIds.add(categoryId);
        });

        // TODO: translate/lookup IDs first (once/if we have data though)
        if (externalCategoryIds.length) {
            updatedCategories.values.forEach((category) =>
            {
                if (!externalCategoryIds.includes(category.externalId))
                    return;

                const categoryIds = updateCategorySelection(
                    category.id, true, updatedBooks, updatedCategories);

                for (let categoryId of categoryIds)
                    affectedCategoryIds.add(categoryId);
            });
        }

        updateAncestorCategories(
            affectedCategoryIds, updatedBooks, updatedCategories, false);

        setBooksWrapper(updatedBooks);
        setCategoriesWrapper(updatedCategories);
    }

    const callbacks = {
        gotData,
        openCloseCategory,
        selectUnselectCategory,
        selectUnselectBook,
        setSelected,
    };

    const onMessage = useCallback((event) =>
    {
        const type = event.detail.type;
        const payload = event.detail.payload;

        const callback = callbacks[type];

        if (callback) {
            callback(payload);
            return;
        }

        console.info('unknown message type!', type, payload);

    }, []);

    // from tei4u / Rešl dictionary web interface (simplified)
    useEffect(() =>
    {
        const eventName = 'onMessage';
        const callback = onMessage;

        inboundEventsHub.addEventListener(eventName, callback, false);

        return () =>
        {
            inboundEventsHub.removeEventListener(eventName, callback, false);
        };
    });

    return (
        <LocalizationProvider l10n={l10n}>
            {/* @ts-ignore */}
            <ReactTreeSelect
                initialized={initialized}
                books={books}
                categories={categories}
                enableFilter={enableFilter}
                filter={filter}
                rootCategoryId={rootCategoryId}
                setBooks={setBooksWrapper}
                setCategories={setCategoriesWrapper}
                setFilter={setFilterWrapper}
                openAtStart={openAtStart}
                adapter={adapter}
                legacy={legacy}
                enableFavorites={enableFavorites}
            />
        </LocalizationProvider>
    );
};

//  XXX: default exports are not supported by the loadUMD2GlobalHack
export { ReactTreeSelectWrapper };
